module.exports = __webpack_public_path__ + "assets/15d33ecf0eef70d3039b20cb54b72d89.png";